import { createFileRoute } from "@tanstack/react-router";
import { RestaurantDetailPage } from "../../features/restaurants/detail-page";

export const Route = createFileRoute("/restaurants/$restaurantId")({ component: Page });

function Page() {
	const { restaurantId } = Route.useParams();
	return <RestaurantDetailPage key={restaurantId} restaurantId={restaurantId} />;
}
